(function () {
	window.js = window.js || {};
	js.searchSuggest = (function () {
		var _domElm,
			_searchInput,
			currentFocus,
			_loadInProgress=false;

		function closeAllLists(elmnt) {
			/*close all autocomplete lists in the document,
			except the one passed as an argument:*/
			var x = document.getElementsByClassName("autocomplete-items");
			for (var i = 0; i < x.length; i++) {
				if (elmnt != x[i] && elmnt != _searchInput) {
					_searchInput.classList.remove("has-value");
					x[i].parentNode.removeChild(x[i]);
				}
			}
		}

		function removeActive(x) {
			/*a function to remove the "active" class from all autocomplete items:*/
			for (var i = 0; i < x.length; i++) {
				x[i].classList.remove("autocomplete-active");
			}
		}

		function addActive(x) {
			/*a function to classify an item as "active":*/
			if (!x) return false;
			/*start by removing the "active" class on all items:*/
			removeActive(x);
			if (currentFocus >= x.length) currentFocus = 0;
			if (currentFocus < 0) currentFocus = (x.length - 1);
			/*add class "autocomplete-active":*/
			x[currentFocus].classList.add("autocomplete-active");
		}

		function loadSuggestions(searchtext,inputElem) {
			_loadInProgress = true;
			var url = '/api/searchapi/suggest?search={keyword}'.replace('{keyword}', searchtext);
			currentFocus = -1;
			var divElem = inputElem.parentElement.parentElement;
			var searchPromise = fetch(url);
			searchPromise.then(function (result) {
				var resultStreamPromise = result.json();
				resultStreamPromise.then(function (searchResult) {
					if (searchResult && searchResult.length > 0) {
						var a = document.createElement("ul");
						a.setAttribute("id", _searchInput.id+"_" + "autocomplete-list");
						a.setAttribute("class", "autocomplete-items");
						divElem.appendChild(a)
						searchResult.forEach(function (item) {
							var b = document.createElement("li");
							var idx = item.toUpperCase().indexOf(searchtext.toUpperCase())
							if (idx > -1) {
								b.innerHTML = item.substr(0, idx);
								b.innerHTML += "<strong>" + item.substr(idx, searchtext.length) + "</strong>";
								b.innerHTML += item.substr(searchtext.length+idx);
							} else {
								b.innerHTML = item;
							}
							b.addEventListener("click", function (e) {
								inputElem.value = item;
								currentFocus = -1;
								closeAllLists();
								inputElem.classList.add('has-value');
								inputElem.parentNode.submit();
							});
							a.appendChild(b);
							//console.log(item);
						});
					}

				});
			}).finally(function () { _loadInProgress = false; });
        }


		function initialize(domElm) {
			_domElm = domElm;
			_searchInput = _domElm.querySelector('.search__panel-input');
			if (_searchInput) {
				_searchInput.addEventListener('input', function (e) {
					closeAllLists();
					var val = this.value;
					if (val.length >= 1 && !_loadInProgress) {
						this.classList.add("has-value");
						loadSuggestions(val,this);
                    }
					
				});
				_searchInput.addEventListener("keydown", function (e) {
					//console.log(currentFocus);
					var x = document.getElementById(_searchInput.id + "_"+ "autocomplete-list");
					if (x) x = x.getElementsByTagName("li");
					if (e.keyCode == 40) {
						/*If the arrow DOWN key is pressed,
						increase the currentFocus variable:*/
						currentFocus++;
						/*and and make the current item more visible:*/
						addActive(x);
					} else if (e.keyCode == 38) { //up
						/*If the arrow UP key is pressed,
						decrease the currentFocus variable:*/
						currentFocus--;
						/*and and make the current item more visible:*/
						addActive(x);
					} else if (e.keyCode == 13) {
						//!TODO: Only preventDefault if we are on an item in autocomplete
						/*If the ENTER key is pressed, prevent the form from being submitted,*/
						if (currentFocus > -1) {
							e.preventDefault();
							if (x) x[currentFocus].click();
						}
						inputElem.parentNode.submit();
					}
				});
			}
		}

		return {
			initialize: initialize
		};

	})();
})();